import { IntegrationConnection } from '@/iam/types';
import api from '../../API';

export interface NewConnection {
  serviceAccountId: number,
  profileId: number,
}

export function create(connection: NewConnection): Promise<IntegrationConnection> {
  return api
    .post('integration-connections', connection)
    .then(response => response.data);
}
